package com.essntl.core.settings.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.core.settings.data")
class ConfigurationModule
